/**
 * Sticky Navbar
 * Enable sticky behaviour of navigation bar on page scroll
*/

const stickyNavbar = (() => {

  let navbar = document.querySelector('.navbar');

  if (navbar == null) return;

  let navbarClass = navbar.classList,
      navbarH = navbar.offsetHeight,
      scrollOffset = 500;

  window.addEventListener('scroll', (e) => {
    if (e.currentTarget.pageYOffset > scrollOffset) {
      navbar.classList.add('navbar-stuck');
    } else {
      navbar.classList.remove('navbar-stuck');
    }
  });

})();

export default stickyNavbar;
